export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: that.disabled ? 80 : 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_fileName') || '文档名称',
    field: 'fileName',
    align: 'left',
    headerAlign: 'center',
    width: 280,
    showOverflow: true,
    sortable: true,
  },
  {
    title: '文档类型',
    field: 'docType',
    align: 'center',
    width: 120,
    showOverflow: true,
    sortable: true,
    slots: { default: 'docType' },
    visible: that.disabled,
  },
  {
    title: that.$l('table_label_fileRemark') || '备注说明',
    field: 'remark',
    align: 'left',
    headerAlign: 'center',
    minWidth: 300,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 250,
        showWordLimit: true,
      },
    },
  },
  {
    title: that.$l('table_label_uploadByName') || '上传人',
    field: 'uploadByName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fileName') || '上传时间',
    field: 'uploadTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
